import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1bcf0e74&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1bcf0e74&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcf0e74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bcf0e74')) {
      api.createRecord('1bcf0e74', component.options)
    } else {
      api.reload('1bcf0e74', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1bcf0e74&scoped=true", function () {
      api.rerender('1bcf0e74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/lead/index.vue"
export default component.exports